import { Routes } from '@angular/router';
import { ViabilidadeGuard } from './viabilidade-agente/viabilidade.guard';
import { ConfiguracaoComponent } from './configuracao/configuracao.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FichaCadastroComponent } from './ficha-veiculo/ficha-cadastro/ficha-cadastro.component';
import { FichaListaComponent } from './ficha-veiculo/ficha-lista/ficha-lista.component';
import { FichaTimelineComponent } from './ficha-veiculo/ficha-timeline/ficha-timeline.component';
import { InicioComponent } from './ficha/cadastro/inicio/inicio.component';
import { AuthenticationComponent } from './login/authentication/authentication.component';
import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login/login.guard';
import { PromotorGuard } from './services/guards/promotor.guard';
import { TipoLojistaGuard } from './services/guards/tipo-lojista.guard';
import { SimuladorComponent } from './simulador/simulador.component';
const ɵ0 = () => import("./produtos/cdc-loja/cdc-loja.module.ngfactory").then((m) => m.CdcLojaModuleNgFactory), ɵ1 = () => import("./produtos/cp/cp.module.ngfactory").then((m) => m.CpModuleNgFactory), ɵ2 = () => import("./ficha-veiculo/ficha-verificacao-seguranca/ficha-verificacao-seguranca.module.ngfactory").then((m) => m.FichaVerificacaoSegurancaModuleNgFactory), ɵ3 = () => import("./simulador-veiculo/simulador-veiculo.module.ngfactory").then((m) => m.SimuladorVeiculoModuleNgFactory), ɵ4 = () => import("./viabilidade-agente/viabilidade-agente.module.ngfactory").then((m) => m.ViabilidadeAgenteModuleNgFactory), ɵ5 = () => import("./produtos/cdc-loja/verificacao-seguranca/verificacao-seguranca.module.ngfactory").then((m) => m.VerificacaoSegurancaModuleNgFactory), ɵ6 = () => import("./produtos/leads/leads.module.ngfactory").then((m) => m.LeadsOnlineModuleNgFactory), ɵ7 = () => import("./parametros-cobranca/parametros-cobranca.module.ngfactory").then((m) => m.ParametrosCobrancaModuleNgFactory), ɵ8 = () => import("./efetive-mais/efetive-mais.module.ngfactory").then((m) => m.EfetiveMaisModuleNgFactory), ɵ9 = () => import("./giro-mais/giro-mais.module.ngfactory").then((m) => m.GiroMaisModuleNgFactory), ɵ10 = () => import("./pesquisa-agente-cep/pesquisa-agente-cep.module.ngfactory").then((m) => m.PesquisaAgenteCepModuleNgFactory), ɵ11 = () => import("./viabilidade-agente/viabilidade-agente.module.ngfactory").then((m) => m.ViabilidadeAgenteModuleNgFactory), ɵ12 = () => import("./agentes/agentes.module.ngfactory").then((m) => m.AgentesModuleNgFactory), ɵ13 = () => import("./produtos/cdc-loja/verificacao-seguranca/verificacao-seguranca.module.ngfactory").then((m) => m.VerificacaoSegurancaModuleNgFactory), ɵ14 = () => import("./agentes/agentes.module.ngfactory").then((m) => m.AgentesModuleNgFactory), ɵ15 = () => import("./customer-acceptance/customer-acceptance.module.ngfactory").then((m) => m.CustomerAcceptanceModuleNgFactory);
const appRoutes = [
    { path: 'login', component: LoginComponent },
    { path: 'authentication', component: AuthenticationComponent },
    {
        path: 'ficha',
        component: FichaListaComponent,
        canActivate: [LoginGuard, PromotorGuard, TipoLojistaGuard],
    },
    {
        path: 'timeline',
        component: FichaTimelineComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'nova',
        component: InicioComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'resultadoparcial/:id',
        component: FichaCadastroComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'nova-ficha-veiculo/:produto/:solicitante',
        component: FichaCadastroComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'novaplaca/:id',
        component: FichaCadastroComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'informargarantia/:id',
        component: FichaCadastroComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'meu-desempenho',
        component: DashboardComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'configuracoes',
        component: ConfiguracaoComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'ficha/nova',
        component: InicioComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'produtos/cdcloja',
        loadChildren: ɵ0,
        canActivate: [LoginGuard],
    },
    {
        path: 'produtos/cp',
        loadChildren: ɵ1,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'simulador',
        component: SimuladorComponent,
        canActivate: [LoginGuard, PromotorGuard],
    },
    {
        path: 'verificacao-seguranca/:tipoComunicacao/:chave',
        loadChildren: ɵ2,
    },
    {
        path: 'simulador-veiculo',
        loadChildren: ɵ3,
    },
    {
        path: 'viabilidade',
        loadChildren: ɵ4,
        canActivateChild: [ViabilidadeGuard],
    },
    {
        path: 'ecommerce/verificacao-seguranca',
        loadChildren: ɵ5,
    },
    {
        path: 'produtos/leads',
        loadChildren: ɵ6,
        canActivate: [LoginGuard],
    },
    {
        path: 'parametro-cobranca/:login/:token/:agente',
        loadChildren: ɵ7,
    },
    {
        path: 'efetive-mais/:login/:token/:agente',
        loadChildren: ɵ8,
    },
    {
        path: 'giro-mais/:login/:token/:agente',
        loadChildren: ɵ9,
    },
    {
        path: 'pesquisa-agente-cep/:login/:token',
        loadChildren: ɵ10,
    },
    {
        path: 'viabilidade',
        loadChildren: ɵ11,
        canActivateChild: [ViabilidadeGuard],
    },
    {
        path: 'ficha-cadastral/:id/:login/:token',
        loadChildren: ɵ12,
    },
    {
        path: 'verificacao-seguranca',
        loadChildren: ɵ13,
    },
    {
        path: 'ficha-cadastral/:id/:login/:token',
        loadChildren: ɵ14,
    },
    {
        path: 'verificacao-seguranca/aceite-cliente/:tipoComunicacao/:chave',
        loadChildren: ɵ15,
    },
    { path: '**', redirectTo: 'login' },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
